import React, { useState } from "react";
import { useParams } from "react-router-dom";
import TabPanel from "../Tabpanel";
import {
  Grid,
  Typography,
  Alert,
  Box,
} from "@mui/material";
import { useQuery } from "react-query";
import { detailsTabsBoxStyle } from "../../services/Utils";
import CircularProgress from "@mui/material/CircularProgress";
import {
  getDeploymentDetails,
  getDeploymentAudits,
} from "../../services/vehicle";
import DeploymentJobDocumentTab from "../deployment/DeploymentJobDocumentTab";
import VehicleDeploymentList from "../deployment/VehicleDeploymentList";
import Constants from "../../services/Constants";
import VehicleDeploymentListV1 from "../deployment/VehicleDeploymentListV1";
import DeploymentProgressTracker from "./DeploymentProgressTracker"; // ← new component

const VehicleDeploymentDetails = () => {
  let { vehicleId, deploymentId } = useParams();

  const [errMsg, setErrMsg] = useState("");
  const [showJobDocument, setShowJobDocument] = useState(false);

  // Deployment details query
  const {
    data: { data: deploymentDetail = {} } = {},
    isLoading: deploymentLoading,
  } = useQuery(
    ["deploymentDetails", deploymentId, vehicleId],
    getDeploymentDetails,
    {
      refetchOnWindowFocus: false,
      onSuccess: (resp) => {
        const { data: { job = {} } = {} } = resp;
        // if (!job?.jobId) {
        //   setErrMsg("Deployment not yet published  this device");
        // }
      },
      onError: () => {
        //const {response: {data: {message = ""} = {}} = {}} = error;
        setErrMsg(Constants.COMMON_DEP_ERR_MSG);
      },
    }
  );

  // jobExecutions Queries
  const { data: { data: jobAuditData = [] } = {} } = useQuery(
    ["deploymentAudits", deploymentId, vehicleId],
    getDeploymentAudits,
    {
      refetchOnWindowFocus: false,
    }
  );

  if (deploymentLoading) {
    return <CircularProgress />;
  }
  if (errMsg) {
    return (
      <Box {...detailsTabsBoxStyle}>
        <Alert variant="outlined" severity="warning">
          {errMsg}
        </Alert>
      </Box>
    );
  }

  const { deploymentStatus = "", deploymentVersion = "V2" } = deploymentDetail;

  const vehicles = deploymentDetail?.vehicle;

  return (
    <TabPanel>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ mt: "16px" }}>
          <Typography
            style={{ marginBottom: "8px", paddingBottom: "0" }}
            className="details-heading"
          >
            Deployment Detail
          </Typography>
          {deploymentVersion === "V1" ? (
            <VehicleDeploymentListV1
              vehicles={vehicles}
              setErrMsg={setErrMsg}
              setShowJobDocument={setShowJobDocument}
              deploymentStatus={deploymentStatus}
              type="vehicle"
            />
          ) : (
            <VehicleDeploymentList
              vehicles={vehicles}
              setErrMsg={setErrMsg}
              setShowJobDocument={setShowJobDocument}
              deploymentStatus={deploymentStatus}
              type="vehicle"
            />
          )}
        </Grid>
        {showJobDocument && (
          <Grid item xs={12} sx={{ mt: "16px" }}>
            <DeploymentProgressTracker auditData={jobAuditData} />
          </Grid>
        )}

        {/* Job Document */}
        {showJobDocument && (
          <Grid item xs={12} sx={{ mt: "16px" }}>
            <Typography
              style={{ marginBottom: "8px", paddingBottom: "0" }}
              className="details-heading"
            >
              Job Document
            </Typography>
            <DeploymentJobDocumentTab />
          </Grid>
        )}

      </Grid>
    </TabPanel>
  );
};

export default VehicleDeploymentDetails;